<script setup lang="ts">
import type { CmsBlockImageTextCover } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockImageTextCover;
  class: any;
  style: any;
}>();

const { getSlotContent } = useCmsBlock(props.content);

const leftContent = getSlotContent("left");
const rightContent = getSlotContent("right");
</script>
<template>
  <section class="section section-main" :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__body">
        <div class="section__content section__content--alt">
          <div class="row">
            <div class="col-12 col-md-6">
              <CmsGenericElement
                  :content="leftContent"
                  class="cms-block-image-text-cover__image"
              />
            </div>
            <div class="col-12 col-md-6">
              <CmsGenericElement
                  :content="rightContent"
                  class="cms-block-image-text-cover__text"
              />
            </div>
          </div>
        </div><!-- /.section__content -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>
